import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface PageLoadingProps {
  /**
   * Optional class overrides for the outer container. Defaults to a full-screen
   * centered layout (`min-h-screen`). Pass a different height utility (e.g.
   * `rounded-md border py-8`) when embedding inside a page section.
   */
  className?: string;
}

/**
 * Centered spinner + "Loading..." label for full-page or full-section loading
 * states. Replaces ad-hoc `<div>Loading...</div>` placeholders.
 */
export const PageLoading = ({ className }: PageLoadingProps) => {
  return (
    <div
      className={cn(
        'flex w-full items-center justify-center',
        className ?? 'min-h-screen',
      )}
    >
      <div className="flex flex-col items-center space-y-3">
        <Loader2 className="text-primary size-6 animate-spin" />
        <p className="text-muted-foreground text-sm">Loading...</p>
      </div>
    </div>
  );
};
